export enum IsoCurrencyEnum {
  EUR = 'EUR',
  AUD = 'AUD',
  GBP = 'GBP',
}

export enum CurrencySymbolsEnum {
  EUR = '€',
  AUD = '$',
  GBP = '£',
}

export const getCurrencyISOCode = (currency: string) => {
  switch (currency) {
    case CurrencySymbolsEnum.AUD:
      return IsoCurrencyEnum.AUD;
    case CurrencySymbolsEnum.GBP:
      return IsoCurrencyEnum.GBP;
    case CurrencySymbolsEnum.EUR:
    default:
      return IsoCurrencyEnum.EUR;
  }
};
